var setResponseBody = function (response, value) {
    Object.defineProperty(response, 'body', {
        value: value,
        enumerable: true,
    });
};
var responseParsers = {
    text: function (response) {
        return response.text().then(function (text) {
            setResponseBody(response, text);
            return Promise.resolve(response);
        });
    },
    blob: function (response) {
        return response.blob().then(function (blob) {
            setResponseBody(response, blob);
            return Promise.resolve(response);
        });
    },
    arrayBuffer: function (response) {
        return response.arrayBuffer().then(function (buffer) {
            setResponseBody(response, buffer);
            return Promise.resolve(response);
        });
    },
    formData: function (response) {
        return response.formData().then(function (data) {
            setResponseBody(response, data);
            return Promise.resolve(response);
        });
    },
    rawStream: function (response) {
        return Promise.resolve(response).then(function (data) {
            setResponseBody(response, data.body);
            return Promise.resolve(response);
        });
    },
    buffer: function (response) {
        var formatResolver = 'buffer' in response ? response.buffer() : response.arrayBuffer();
        return formatResolver.then(function (data) {
            setResponseBody(response, data);
            return Promise.resolve(response);
        });
    },
    json: function (response) {
        var contentType = response.headers.get('content-type') || '';
        return response
            .text()
            .then(function (text) {
            return text && text.length && contentType.includes('application/json')
                ? JSON.parse(text)
                : text;
        })
            .then(function (parsedBody) {
            setResponseBody(response, parsedBody);
            return Promise.resolve(response);
        });
    },
};
export default responseParsers;
//# sourceMappingURL=responseParsers.js.map